query getInventoryStateLegacy($date: DateTime) {
	inventoryStateLegacy(date: $date) {
		...fullInventoryState
	}
}